import React, { useEffect, useRef, useState } from "react";
import { FormattedMessage } from "react-intl";
import {
  CircularProgress,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  Typography,
} from "@material-ui/core";
import ActionDialog from "../../ActionDialog";
import { editAgreementClass, getClasses } from "../../../../actions";
import { useManagementAction } from "../../../../hooks/useManagementAction";

const ChangeAgentLevel = ({
  open,
  handleCloseDialog,
  onComplete,
  user,
  fetchUser,
}) => {
  const { handleManagementAction } = useManagementAction();

  const initialAgentLevel = user.contractAgent.contractAgentClass.id;
  const [loadingState, setLoadingState] = useState("idle");
  const [selectedLevel, setSelectedLevel] = useState(() => initialAgentLevel);
  const [levels, setLevels] = useState([]);

  const isMountedRef = useRef(true);
  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const onTaskComplete = async () => {
    if (!isMountedRef.current) return;
    await fetchUser();
    setLoadingState("idle");
    onComplete();
  };

  const onFinish = () => {
    if (!isMountedRef.current) return;

    setLoadingState("idle");
    handleCloseDialog();
  };

  const handleSubmit = async () => {
    setLoadingState("submitting");
    await handleManagementAction({
      body: { editedUserId: user.id, classId: selectedLevel },
      managementAction: editAgreementClass,
      onComplete: onTaskComplete,
      onFinish,
      successMessage: "app.edit.sucesfully",
    });
  };

  const handleClose = () => {
    setSelectedLevel(initialAgentLevel);
    handleCloseDialog();
  };

  useEffect(() => {
    const fetchData = async () => {
      const levelsData = await getClasses();
      setLevels(levelsData);
    };
    fetchData();
  }, []);

  return (
    <ActionDialog
      title="app.edit"
      open={open}
      onAccept={handleSubmit}
      onClose={handleClose}
      textConfirm="app.edit"
      maxWidth="xs"
      disableConfirmButton={
        ["fetching", "submitting"].includes(loadingState) ||
        initialAgentLevel === selectedLevel
      }
      textToConfirmation={"app.confirm.changeAgentLevel"}
    >
      {["submitting", "idle"].includes(loadingState) && (
        <FormControl
          fullWidth
          variant="outlined"
          size="small"
        >
          <InputLabel
            id="level-label"
            shrink
          >
            <FormattedMessage id="app.manager.userLevel" />
          </InputLabel>

          <Select
            labelId="level-label"
            value={selectedLevel}
            renderValue={(selectedId) => {
              const selected = levels.find((l) => l.id === selectedId);
              return selected ? (
                <Typography component={"span"}>
                  <FormattedMessage id={`app.enuns.levelName.${selected.levelName}`} />
                </Typography>
              ) : (
                ""
              );
            }}
            notched
            label={<FormattedMessage id="app.manager.userLevel" />}
            onChange={(e) => setSelectedLevel(e.target.value)}
            inputlabelprops={{
              shrink: true,
              disabled: ["fetching", "submitting"].includes(loadingState),
            }}
            disabled={["fetching", "submitting"].includes(loadingState)}
          >
            {levels
              .sort((a, b) => a.id - b.id)
              .map(({ id, levelValue, levelName }) => (
                <MenuItem
                  key={id}
                  value={id}
                >
                  <ListItemText
                    primary={
                      <Typography component={"span"}>
                        <FormattedMessage id={`app.enuns.levelName.${levelName}`} />
                      </Typography>
                    }
                  />
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      )}

      {["fetching", "submitting"].includes(loadingState) && (
        <div style={{ textAlign: "center", marginTop: 12 }}>
          <CircularProgress />
        </div>
      )}
    </ActionDialog>
  );
};

export default ChangeAgentLevel;
